import React from 'react';
import { FiberNew } from '@mui/icons-material';
import { primaryShades } from '../../../theme/theme';

const NewBadge = ({ children, showBadge = false, style = {} }) => {
    if (!showBadge) {
        return children;
    }

    return (
        <div style={{
            position: 'relative',
            display: 'inline-block',
            ...style
        }}>
            {children}
            <FiberNew
                style={{
                    color: primaryShades.primary300,
                    fontSize: '1.5rem',
                    position: 'absolute',
                    top: '-0.8rem',
                    right: '-1.5rem',
                    zIndex: 1000,
                    filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.2))'
                }}
            />
        </div>
    );
};

export default NewBadge; 